import { FlagsModule } from '@seddi/ui-feature-flags';
import { useCallback, useEffect, useMemo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { downloadImage } from '../../actions/captureImage';
import { setViewerRef } from '../../store/appRefsSlice';
import { getScene } from '../../store/appSlice';
import type { TRootState } from '../../store/appStateTypes';
// TODO: This coupling should not exist
import { notifyRenderComplete } from '../../windowController';

const featureFlagsDef = {
  depthPeelingLayers: 0,
  disableTransparencyAngleBasedCompensation: false,
  disableTransparencyFlatCompensation: false,
  mipMapsGaussianBlur: false,
  parallax: false,
  premultipliedAlphaLogos: true,
  wireframeFabrics: false,
} as const;

const visibleDef = {
  avatar: false,
  background: false,
  garmentHem: true,
  garmentPiece: true,
  garmentSeam: true,
  ground: false,
  logos: true,
} as const;

export const useAppViewer = () => {
  const dispatch = useDispatch();
  const resolution = useSelector((state: TRootState) => state.app.resolution);
  const sceneVersion = useSelector((state: TRootState) => state.app.sceneVersion);

  const viewerRef = useRef<any>(null);

  useEffect(() => {
    // communicate viewerRef through state
    dispatch(setViewerRef(viewerRef));
    // clear viewerRef state
    return () => {
      dispatch(setViewerRef(null));
    };
  }, [dispatch]);

  const config = useMemo(() => {
    const useStitchesDecals = FlagsModule.isEnabled('use_stitches_decals');
    return { frustumCulling: false, useStitchesDecals };
  }, []);

  const scene = useMemo(() => {
    return getScene();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- sceneVersion is intended to memoize the new scene
  }, [sceneVersion]);

  const featureFlags = featureFlagsDef;
  const visible = visibleDef;

  const handleDownloadImage = useCallback(() => {
    if (viewerRef.current) {
      downloadImage(viewerRef.current, 'image/webp');
    }
  }, []);

  // Callback that fires after each render completes
  // This resolves promises from waitForRender() calls
  const handleUpdate = useCallback(() => {
    notifyRenderComplete();
  }, []);

  return {
    config,
    featureFlags,
    handleDownloadImage,
    handleUpdate,
    resolution,
    scene,
    viewerRef,
    visible,
  };
};
